import React from "react";
import { Icon } from "../core/Icon.jsx";

/** Dress-code statement with optional palette swatches and "colours to avoid". */
export function DressCode({ code = "Formal", note, palette = [], avoid = [], avoidLabel = "Reservado para la novia", style }) {
  return (
    <div style={{ display: "grid", justifyItems: "center", gap: "var(--sp-4)", textAlign: "center", ...style }}>
      <Icon name="shirt" size={34} style={{ color: "var(--accent)" }} />
      <p style={{ margin: 0, fontFamily: "var(--font-title, var(--font-display))", fontSize: "var(--fs-title)", letterSpacing: "0.02em", color: "var(--fg-primary)" }}>{code}</p>
      {note && <p style={{ margin: 0, maxWidth: 300, fontSize: "var(--fs-body-s)", lineHeight: "var(--lh-loose)", color: "var(--fg-secondary)" }}>{note}</p>}
      {palette.length > 0 && (
        <div style={{ display: "flex", gap: "var(--sp-2)", marginTop: "var(--sp-2)" }}>
          {palette.map((c, i) => (
            <span key={i} title={c} style={{ width: 34, height: 34, borderRadius: "50%", background: c, boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.08)" }} />
          ))}
        </div>
      )}
      {avoid.length > 0 && (
        <div style={{ display: "grid", justifyItems: "center", gap: "var(--sp-2)", marginTop: "var(--sp-3)" }}>
          <p style={{ margin: 0, fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-body)", color: "var(--fg-muted)" }}>{avoidLabel}</p>
          <div style={{ display: "flex", gap: "var(--sp-2)" }}>
            {avoid.map((c, i) => (
              <span key={i} style={{ position: "relative", width: 26, height: 26, borderRadius: "50%", background: c, boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.08)" }}>
                <span style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", color: "var(--state-danger)", fontSize: 18, lineHeight: 1 }}>⁄</span>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
